declare namespace $ {

	type $mol_link_source__Icon_idle_app_1 = $mol_type_enforce<
		ReturnType< $idle_app['Telegram_icon'] >
		,
		ReturnType< $mol_link_source['Icon'] >
	>
	type $mol_link_source__uri_idle_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_link_source__uri_idle_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	export class $idle_app extends $mol_book2_catalog {
		Telegram_icon( ): $mol_icon_telegram
		Telegram( ): $mol_link_source
		Sources( ): $mol_link_source
		Dice_page( ): $idle_app_dice
		Dps_page( ): $idle_app_dps
		menu_title( ): string
		menu_tools( ): readonly(any)[]
		param( ): string
		spreads( ): ({ 
			'dice': ReturnType< $idle_app['Dice_page'] >,
			'dps': ReturnType< $idle_app['Dps_page'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map